/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable import/exports-last */
import React from 'react'
import mfeConfig from '../../../config/mfe-config'
import ModuleLoader from '../MFE/ModuleLoader'

declare const __BROWSER__: any

export type VehicleSearchType = 'banner' | 'HeaderDropdown' | 'dialog'

export type VehicleWmo = {
  id: string;
  make: string;
  model: string;
  year: string;
  subModel?: string;
  engine?: string;
  selected?: boolean;
  image?: string;
}

export enum VehiclePropertyField {
  YEAR = 'year',
  MAKE = 'make',
  MODEL = 'model',
  SUBMODEL = 'submodel',
  ENGINE = 'engine',
}

export enum AddVehicleMethod {
  VEHICLE_PROPERTY = 'vehicleProperty',
  VIN = 'vin',
}

export interface IVehicleSelectorWmo {
  fallbackSuspense?: React.ComponentType
  componentType: VehicleSearchType
  button?: React.ComponentType | unknown
  onVehiclePropertyChange?: (
    property: VehiclePropertyField,
    value: string,
  ) => void
  onAddVehicle: (vehicle:VehicleWmo, addMethod: AddVehicleMethod) => void
  onVinLookup?: (vinNumber: string) => void
  onPropertyLookup?: (attrs: Pick<VehicleWmo, 'year' | 'make' | 'model' | 'subModel' | 'engine'>) => void
  onDeleteVehicles?: (vehicles: VehicleWmo[]) => void
  onSelectVehicle?: (vehicle: VehicleWmo) => void
  shouldRedirect?:boolean
  forceNoYMMToastDefaultTrigger?: boolean
}

const VehicleSelectorWmo: React.FC<IVehicleSelectorWmo> =
  ({
    fallbackSuspense = null,
    componentType,
    button,
    onVehiclePropertyChange,
    onAddVehicle,
    onVinLookup,
    onPropertyLookup,
    onDeleteVehicles,
    onSelectVehicle,
    shouldRedirect,
    forceNoYMMToastDefaultTrigger,
  }) => {
    return (
    <aside data-testid="mfe-vs-search-wrapper">
      {__BROWSER__ &&
        (
          <ModuleLoader
            url={mfeConfig.vehicleSearchComponentAppUrl}
            scope={mfeConfig.vehicleSearchComponentAppName}
            module={mfeConfig.vehicleSearchComponentAppModule}
            fallbackSuspense={fallbackSuspense}
            mfeComponentParameters={{
              component: componentType,
              button,
              onVehiclePropertyChange,
              onAddVehicle,
              onVinLookup,
              onPropertyLookup,
              onDeleteVehicles,
              onSelectVehicle,
              shouldRedirect,
              forceNoYMMToastDefaultTrigger,
            }}
          />
        )}
    </aside>
  )}

export default React.memo(VehicleSelectorWmo)
